// src/pages/MPFlow/components/targeting/LocationSelector.jsx
import React, { useState, useRef, useEffect } from 'react';

const POPULAR_LOCATIONS = [
  { label: 'Brasil inteiro', value: 'BR', type: 'country' },
  { label: 'São Paulo, SP', value: 'SP-SAO_PAULO', type: 'city' },
  { label: 'Rio de Janeiro, RJ', value: 'RJ-RIO_DE_JANEIRO', type: 'city' },
  { label: 'Belo Horizonte, MG', value: 'MG-BELO_HORIZONTE', type: 'city' },
  { label: 'Curitiba, PR', value: 'PR-CURITIBA', type: 'city' },
  { label: 'Porto Alegre, RS', value: 'RS-PORTO_ALEGRE', type: 'city' },
  { label: 'Brasília, DF', value: 'DF-BRASILIA', type: 'city' },
  { label: 'Salvador, BA', value: 'BA-SALVADOR', type: 'city' },
  { label: 'Fortaleza, CE', value: 'CE-FORTALEZA', type: 'city' },
  { label: 'Recife, PE', value: 'PE-RECIFE', type: 'city' },
  { label: 'Manaus, AM', value: 'AM-MANAUS', type: 'city' },
];

export default function LocationSelector({ value, onChange }) {
  const [query, setQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const filtered = POPULAR_LOCATIONS.filter((loc) =>
    loc.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (loc) => {
    onChange({ location: loc.label, location_key: loc.value, location_type: loc.type });
    setQuery('');
    setShowDropdown(false);
  };

  return (
    <div className="seg-location" ref={wrapperRef}>
      <input
        className="mp-field__input"
        type="text"
        value={query || (value?.location || '')}
        onChange={(e) => { setQuery(e.target.value); setShowDropdown(true); }}
        onFocus={() => setShowDropdown(true)}
        placeholder="Buscar cidade, estado ou país..."
      />
      {showDropdown && (
        <div className="seg-location__dropdown">
          {filtered.length > 0 ? filtered.map((loc) => (
            <button
              key={loc.value}
              className={`seg-location__item ${value?.location_key === loc.value ? 'seg-location__item--active' : ''}`}
              onClick={() => handleSelect(loc)}
              type="button"
            >
              <span className="seg-location__icon">{loc.type === 'country' ? '🌎' : '📍'}</span>
              {loc.label}
            </button>
          )) : (
            <div className="seg-location__empty">Nenhum resultado</div>
          )}
        </div>
      )}
    </div>
  );
}
